import { SET_APP_HOST, GET_CONFIDENTIALITY_LEVELS, GET_QUOTAS, GET_LOCATIONS, SET_NAVIGATION_KEY, GET_MESSAGE_BARS, GET_APP_CONFIGURATION, ADD_MESSAGE_BAR } from "../actions/types";
import { ConfidentialityLevel } from "../GlobalConst/globalEnums";
import { mapEnumToFilterValues } from "../helpers/HelperMethods";

const initialState = {
    navigation: null,
    hostApp: null,
    isMsTeamsApp: false,
    siteConfidentialityLevels: mapEnumToFilterValues(ConfidentialityLevel),
    siteQuotas: [],
    siteLocations: [],
    messageBars: [],
    appConfiguration: {}
};

export default function(state = initialState, action) {
    switch (action.type) {
        case SET_NAVIGATION_KEY:
            return {
                ...state,
                navigation: action.payload
            };
        case SET_APP_HOST:
            return {
                ...state,
                hostApp: action.payload,
                isMsTeamsApp: action.payload === 'teams'
            };
        case GET_CONFIDENTIALITY_LEVELS:
            return {
                ...state,
                siteConfidentialityLevels: action.payload
            }
        case GET_QUOTAS:
            return {
                ...state,
                siteQuotas: action.payload
            }
        case GET_LOCATIONS:
            return {
                ...state,
                siteLocations: action.payload
            }
        case GET_MESSAGE_BARS:
            return {
                ...state,
                messageBars: action.payload
            }
        case GET_APP_CONFIGURATION:
            return {
                ...state,
                appConfiguration: action.payload
            }
        case ADD_MESSAGE_BAR:
            return {
                ...state,
                messageBars: state.messageBars.concat(action.payload)
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/appReducer.js